// extracted by mini-css-extract-plugin
export default {"text":"NavLink_text__JcwW5","block":"NavLink_block__ssAOW"};